import {Injectable} from "@angular/core";
import {HttpClient} from '@angular/common/http';
import { map } from 'rxjs/operators';

import {FilterParams} from "app/models/filter_form.model";
import {BaseService} from "app/views/base.service";
import {getUrlParams} from "app/lib/lib";


@Injectable()
export class SiteSubCategoriesService extends BaseService {
	constructor(http: HttpClient) {
		super(http);
	}

	getStats(queryParams: FilterParams): any {
		let params: string = getUrlParams(queryParams);

		return this.q$.push(this.http.get(`/site_sub_categories/stats?${params}`)).pipe(map(r => r[1]));
	}
}
